import { render } from "./GroupRow.vue?vue&type=template&id=d2d0ebba&scoped=true"
import script from "./GroupRow.vue?vue&type=script&lang=js"
export * from "./GroupRow.vue?vue&type=script&lang=js"

import "./GroupRow.vue?vue&type=style&index=0&id=d2d0ebba&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d0ebba"]])

export default __exports__